export default __webpack_public_path__ + "static/media/target-article.a4003ac8.png";